// src/router/AppRouter.tsx — Site officiel Vanessa
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { ModeratorRoute } from './ModeratorRoute';
import { SiteLayout } from '@/components/site/SiteLayout';

import LandingPage from '@/pages/LandingPage';
import PricingPage from '@/pages/PricingPage';
import DocumentationPage from '@/pages/DocumentationPage';
import StatusPage from '@/pages/StatusPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import EmailConfirmedPage from '@/pages/EmailConfirmedPage';
import ConsolePage from '@/pages/ConsolePage';
import AdminPage from '@/pages/AdminPage';
import VanessaPage from '@/pages/VanessaPage';
import TrustPage from '@/pages/TrustPage';
import PrivacyPage from '@/pages/PrivacyPage';
import TermsPage from '@/pages/TermsPage';
import ProductsPage from '@/pages/ProductsPage';
import ProductPage from '@/pages/ProductPage';
import DevelopersPage from '@/pages/DevelopersPage';
import QuickstartPage from '@/pages/QuickstartPage';
import BusinessPage from '@/pages/BusinessPage';
import GuidePage from '@/pages/GuidePage';
import FaqPage from '@/pages/FaqPage';
import ContactPage from '@/pages/ContactPage';
import NotFoundPage from '@/pages/NotFoundPage';

export const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/vanessa" element={<VanessaPage />} />
                    <Route path="/produits" element={<ProductsPage />} />
                    <Route path="/produits/:slug" element={<ProductPage />} />
                    <Route path="/confiance" element={<TrustPage />} />
                    <Route path="/confidentialite" element={<PrivacyPage />} />
                    <Route path="/conditions" element={<TermsPage />} />
                    <Route path="/developpeurs" element={<DevelopersPage />} />
                    <Route path="/developpeurs/demarrage" element={<QuickstartPage />} />
                    <Route path="/entreprises" element={<BusinessPage />} />
                    <Route path="/guide" element={<GuidePage />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/tarifs" element={<PricingPage />} />
                    <Route path="/documentation" element={<DocumentationPage />} />
                    <Route path="/statut" element={<StatusPage />} />
                    <Route path="/connexion" element={<LoginPage />} />
                    <Route path="/inscription" element={<RegisterPage />} />
                    <Route path="/email-confirmed" element={<EmailConfirmedPage />} />

                    <Route
                        path="/console"
                        element={
                            <ProtectedRoute>
                                <ConsolePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ModeratorRoute>
                                <AdminPage />
                            </ModeratorRoute>
                        }
                    />

                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};
